import React from 'react';
import {
  CircleDollarSign,
  GraduationCap,
  Leaf,
  Scale,
  ShieldCheck,
  Stethoscope,
  UsersRound
} from 'lucide-react';

const iconMap = {
  CircleDollarSign,
  GraduationCap,
  Leaf,
  Scale,
  ShieldCheck,
  Stethoscope,
  UsersRound
};

export default function IconRenderer({ name, className = 'h-5 w-5' }) {
  if (!name) {
    return null;
  }

  const Icon = iconMap[name];

  if (!Icon) {
    return null;
  }

  return <Icon className={className} strokeWidth={1.9} />;
}
